import React from 'react';
function Toggle({toggleText, toggleHandler, toggleOn=false}) {
// Need to verfy if this needs to be an <input> under the hood for any accessiblity reasons

    return (
        <>
            <div onClick={e => toggleHandler(e)} style={{ color: '#707070', fontSize: 14, fontFamily: 'Montserrat', fontWeight: '400', wordWrap: 'break-word' }}>{toggleText}</div>
            <div onClick={e => toggleHandler(e)} style={{ width: '100%', height: '100%', padding: 2, background: toggleOn ? '#46C3B2' : '#8D8D8D', borderRadius: 9999, overflow: 'hidden', justifyContent: toggleOn ? 'flex-end' : 'flex-start', alignItems: 'center', display: 'inline-flex', maxWidth: '44px' }}>
                <div style={{ width: 20, height: 20, position: 'relative', background: 'white', borderRadius: 9999 }} />
            </div>
        </>
    )
}

export default Toggle;
